import { QueryClient } from "react-query";

import store from "@/library/redux";
import { setError } from "@/store/error";

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 60 * 1000,
      retry: 0,
      onError: (error) => {
        if (!error.response) {
          store.dispatch(setError({ status: 500 }));
          return;
        }
        store.dispatch(
          setError({
            status: error.response.status,
            message: error.response.data.message,
          }),
        );
      },
    },
    mutations: {
      onError: (error) => {
        if (!error.response) {
          store.dispatch(setError({ status: 500 }));
          return;
        }
        store.dispatch(
          setError({
            status: error.response.status,
            message: error.response.data.message,
          }),
        );
      },
    },
  },
});

export default client;
